<template>
   <div class="header">
        <i @click="goBack" :class="['iconfont','icon-left']" v-if="isBack"></i>
        <i v-else></i>
        <slot>
            <h2>最近来访</h2>
        </slot>
        <span></span>
    </div>
</template>
<script>
export default {
    name: "heads",
    props:['isBack'],
    data(){
        return{

        }
    },
    methods: {
        goBack(){
            this.$router.go(-1)
        }
    }
}
</script>
<style lang="scss">
.header{
    width: 100%;
    height: .9rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 .32rem;
    box-sizing: border-box;
    background:#fff;
    border-bottom: .01rem solid #eee;

    i{
        padding-right: .32rem;
        box-sizing: border-box;
    }

    h2{
        flex:1;
        display: flex;
        padding-right: .32rem;
        box-sizing: border-box;
        justify-content: space-around;
        font-size: .34rem;
        color: #262626;
    }

    span{
        padding-right: .2rem;
    }
}
</style>